import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import Icon from 'base-ui/dist/Icon';
import Button from 'base-ui/dist/Button';
import InputField from 'base-ui/dist/InputField';
import { intl } from 'components/LocaleProvider';
import { FormattedMessage } from 'react-intl';

import NavLink from 'components/NavLink';
import messages from './messages';

const SignInForm = ({ onSubmit }) => {
  const { register, handleSubmit, errors } = useForm();

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <div className="field-with-icon">
        <Icon prefix="far" name="envelope" className="big icon regent-grey-color" style={{ fontSize: '2.125rem' }}></Icon>
        <InputField
          name="email"
          type="email"
          placeholder={intl.formatMessage(messages.labelEmail)}
          className="input full big"
          ref={register({ pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, required: true })}
          meta={{ touched: errors.email, error: (errors.email?.type === 'pattern' && intl.formatMessage(messages.invalidField)) || (errors.email?.type === 'required' && intl.formatMessage(messages.requiredField)), warning: false }}
        />
      </div>
      <div className="field-with-icon">
        <Icon prefix="fas" name="asterisk" className="big icon regent-grey-color" style={{ fontSize: '2rem' }}></Icon>
        <InputField
          name="password"
          type="password"
          placeholder={intl.formatMessage(messages.labelPassword)}
          className="input full big"
          ref={register({ required: true })}
          meta={{ touched: errors.password, error: intl.formatMessage(messages.requiredField), warning: false }}
        />
      </div>
      <div className="align-right font-normal-small margin-bottom-medium">
        <FormattedMessage tagName="span" {...messages.labelLinkForgotPassword} />
        {' '}
        <NavLink className="highlight grey-border" href={intl.formatMessage(messages.forgotPasswordURL)} target="_blank">
          <FormattedMessage {...messages.labelLinkRecoverPassword} />
        </NavLink>
      </div>
      <Button tag="button" type="submit" className="full big white-bg main-border main-color">
        <FormattedMessage {...messages.labelSignInMContigo} />
      </Button>
    </form>
  );
};

SignInForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
};

export default SignInForm;
